<template>
  <b-modal ref="stop-document" :title="title" hide-footer>
    <div class="d-block text-center">
      <b-container v-if="!documentStopped" fluid class="mt-4 mb-2">
        <div>Voules-vous supprimer ce document ?</div>
        <br>
        <div>Attention, cette action est définitive.</div>
        <div class="mt-4">
          <b-button
            variant="outline-danger"
            @click="hideModal(code)"
            class="mr-2"
            >Annuler</b-button
          >
          <b-button
            variant="primary"
            @click="stopDocument(code)"
          >
            Valider
          </b-button>
        </div>
      </b-container>
      <b-container v-if="documentStopped" fluid>
        <div class="document-stopped-icon">
          <i class="fa fa-check-circle" aria-hidden="true"></i>
        </div>
        <div>Le document a bien été supprimé</div>
        <div class="mt-4 mb-2">
          <b-button
            variant="outline-secondary"
            @click="goTo('/flux')"
          >
            Voir les boucles
          </b-button>
          <b-button
            variant="primary"
            @click="goToTracking()"
            class="mr-2"
            >Trouver un autre document</b-button
          >
        </div>
      </b-container>
    </div>
  </b-modal>
</template>
<script>
import server from '../../api/server.vue'

export default {
  name: 'StopDocumentModal',
  props: [ 'title', 'code' ],
  data () {
    return {
      documentStopped: false,
    }
  },
  methods: {
    hideModal () {
      this.$refs['stop-document'].hide()
    },
    showModal () {
      this.$refs["stop-document"].show()
    },
    goToTracking () {
      this.$emit('reset-form')
      this.hideModal()
      this.goTo('/tracking_order')
    },
    stopDocument (documentCode) {
      server.stopDocument(documentCode).then(() => {
        this.documentStopped = true
      }).catch((er) => {
        console.log(er)
        this.$toasted.error('Oups! Une erreur est survenue')
        this.hideModal()
      })
    }
  }
}

</script>
<style>
.document-stopped-icon {
  font-size: 10rem;
  margin: 0 auto;
  color: var(--success);
}
</style>



// WEBPACK FOOTER //
// src/components/document/StopDocumentModal.vue